document.addEventListener("turbolinks:load", () => {
  const timerContainer = document.getElementById("another-requirement-timer");
  const countdownSpan = document.getElementById("countdown_timer");

  if (!timerContainer || !countdownSpan) return;

  const waitUntil = parseInt(timerContainer.dataset.waitUntil, 10);

  function updateTimer() {
    const now = Date.now();
    const diff = waitUntil - now;

    if (diff <= 0) {
      countdownSpan.textContent = "agora mesmo";
      return;
    }

    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    countdownSpan.textContent = `${minutes} minuto(s) e ${seconds} segundo(s)`;

    setTimeout(updateTimer, 1000);
  }

  updateTimer();
});
